import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/permissions';
import { ResultState } from '@rootCommon/types/common';
import { PermissionTemplate } from '@rootCommon/types/permission';

type Action = ActionType<typeof actions>;
export type PermissionTemplatesState = ResultState<PermissionTemplate[] | null>;

const initState: PermissionTemplatesState = {
  data: null,
  loading: false,
  error: null,
};

export const permissionTemplateReducer = (state = initState, action: Action): PermissionTemplatesState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchPermissionTemplates.request):
      return { ...state, loading: true, error: null };
    case getType(actions.fetchPermissionTemplates.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchPermissionTemplates.failure):
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default permissionTemplateReducer;
